export const IS_PRODUCTION = process.env.REACT_APP_NODE_ENV === 'production';

export const DOMAIN_URL = IS_PRODUCTION ? 'https://cratd2csmartchain.io' : 'https://crat3.rocknblock.io';
const API_PATH = '/api/v1';

export const INVOICE_URL_V2 = IS_PRODUCTION
  ? 'https://tap2mine.cratd2csmartchain.io'
  : 'https://crat3-invoices.rocknblock.io';

export const API_BASE_URL = `${DOMAIN_URL}${API_PATH}`;
export const API_INVOICE_BASE_URL = `${INVOICE_URL_V2}${API_PATH}`;

export const EXPLORER_URL = 'https://explorer.cratd2csmartchain.io';
